import { DEX_ADJUSTMENTS } from "../constants/abilityAdjustments";

export function calculateDexBonus(character) {

  let dexLookupKey = character.stats['myDex'].toString().replace(/[^0-9]/g, ''); // strip out non-numerical

  let DEX_bonus_string ="";
  try {
    const DEX_adj = DEX_ADJUSTMENTS[parseInt(dexLookupKey)]
      console.log('DEX adj: ',DEX_adj)
      let adjuster = DEX_adj['reaction'];
      const react_bonus = adjuster === 0 ? "" :
        (adjuster < 0 ? `-${Math.abs(adjuster)}` : `+${adjuster}`);
      console.log('React: ', react_bonus);

      adjuster = DEX_adj['defense'];
      const def_bonus = adjuster === 0 ? "" :
        (adjuster < 0 ? `-${Math.abs(adjuster)}` : `+${adjuster}`);
      console.log('Defense: ', def_bonus);

      
      if (react_bonus === "" && def_bonus !== "") {
        DEX_bonus_string = '0/' + def_bonus;
      } else if (react_bonus !== "" && def_bonus !== "") {
        DEX_bonus_string = react_bonus + "/" + def_bonus;
      }
      
      return { str: DEX_bonus_string, dict: DEX_adj }
    
  } catch(error) {
    console.log('fail gracefully')
    console.log(error)
  }

}